import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TableModel } from 'src/app/models/table.model';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { ContributorPaymentLogFilterModel } from '../models/contributor.payement.log.filter.model';
import { PagedContributorPaymentLogDetail } from '../models/paged.contributor.payment.log.detail';

@Injectable()
export class PaymentService {

    constructor(private http: HttpClient) { }


    GetContributorPaymentLogs(filterModel: ContributorPaymentLogFilterModel,
        tableModel: TableModel): Observable<PagedContributorPaymentLogDetail> {
        let url = `${environment.apiUrl}/api/photographer/payment/contributor-payment-log`;
        const queryParams = [];
        const tempArr = [];
        if (!isNullOrUndefined(filterModel.year)) {
            tempArr.push(`year=${filterModel.year}`);
        }
        if (!isNullOrUndefined(filterModel.month)) {
            tempArr.push(`month=${filterModel.month}`);
        }
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&') + '&' + tempArr.join('&');
        }
        return this.http.get<PagedContributorPaymentLogDetail>(url);
    }
}
